import MarqueeLib from "react-fast-marquee";
import { useLanguage } from "@/i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLanguage();
  return (
    <div className="border-y border-white/10 py-3" data-testid="editorial-marquee">
      <MarqueeLib speed={25} gradient={false}>
        {t.marquee.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-16 font-mono text-xs uppercase tracking-[0.25em] text-muted2">
            <span>{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-neon" />
          </span>
        ))}
      </MarqueeLib>
    </div>
  );
};

export default Marquee;
